import { z } from 'zod'

export const modificationHistorySchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  updatedBy: z.string(),
  name: z.string(),
  lastName: z.string(),
  status: z.string(),
  reason: z.string().nullable(),
  documentNumber: z.string(),
  email: z.string().email(),
  phone: z.string(),
  birthDate: z.string(),
  creditLimit: z.string()
})

export type ModificationHistory = z.infer<typeof modificationHistorySchema>
